// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__1AyG9","head":"Table_head__g-l_7","col":"Table_col__178QJ"};